import actions from './actions';

const initState = { idToken: null, aLoginMsg: null };

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      return {
        idToken: action.token,
      };
    case actions.ALOGIN:
      return {
        aLoginMsg: action.msg,
      };
    case actions.LOGOUT:
      return initState;
    default:
      return state;
  }
}
